import React from 'react';
import { Grid, List, Icon } from 'semantic-ui-react';

import { Interest } from '../../utility/interfaces';
import { interests } from '../../data/interests';
import _ from 'lodash';

const getSlicedInterests = (allBooks: Interest[]): Interest[][] => {
    if (allBooks.length % 2 !== 0) {
        allBooks.pop();
    }
    return _.chunk(allBooks, allBooks.length / 2);
};

export const Interests = () => {
    const interestsGroups = getSlicedInterests(interests);
    return (
        <Grid columns={2}>
            <Grid.Row>
                {interestsGroups.map((interestsGroup) => (
                    <Grid.Column>
                        <List selection verticalAlign="middle">
                            {interestsGroup.map((interest) => (
                                <List.Item href={null}>
                                    <Icon name={interest.icon} />
                                    <List.Content>
                                        <List.Header>{interest.text}</List.Header>
                                    </List.Content>
                                </List.Item>
                            ))}
                        </List>
                    </Grid.Column>
                ))}
            </Grid.Row>
        </Grid>
    );
};

export default Interests;
